import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import i18next from "i18next";
import { getAllActiveTypeDoc } from "services/edge/DossierModelService";
import { Context } from "states/Store";
import DossierChoiceDocuments from "containers/dossiers/create-dossier/DossierChoiceDocuments";
import EAButton from "components/common/EAButton";
import EAIcon from "components/common/EAIcon";
import useStyles from "./DossierModelDialogStyle";
import { isEmpty } from "lodash";
import { useFormContext } from "react-hook-form";
import { isSealedDocument, isSealedDossier } from "services/common/Constants";

const DossierModelDialogDocStep = ({
  isCreationMode,
  dossierModel = {},
  onCancel,
  onDelete,
  onContinue,
  setData = () => {},
  readOnly = false
}) => {
  const [state, dispatch] = useContext(Context);
  const [allDocuments, setAllDocuments] = useState();
  const [filteredDocuments, setFilteredDocuments] = useState();
  const [documentsSelected, setDocumentsSelected] = useState(dossierModel?.requirements?.map((d) => d.code) || []);
  const [sortedDocuments, setSortedDocuments] = useState();
  const [isDossierTypeCodeToIgnore, setIsDossierTypeCodeToIgnore] = useState(false);
  const { classes } = useStyles();
  const formMethods = useFormContext();
  const firstRenderDone = useRef(false);

  const {
    formState: { errors },
    handleSubmit,
    getValues,
    setValue
  } = formMethods;


// Workaround pour avoir les documents préselctionés. 
// Le onSelectionChange du DataGridPremium à l'air de 
// renvoyer un array vide systématiquement lors du premier render.
// De plus, probablement lié, un listener est créé à chaque 
// changement de sélection : 
// "Possible EventEmitter memory leak detected. 11 stateChange listeners added."
// Pb de fond à revoir pour la gestion de la selection via EADataGrid
const handleSelectionChange = useCallback((docs) => {
  if (firstRenderDone.current) {
    setDocumentsSelected(docs);
  } else {
    firstRenderDone.current = true;
  }
  }, []);

  useEffect(() => {
    if (state.account) {
      (async function fetchData() {
        try {
          const results = await getAllActiveTypeDoc(state.account.id, dispatch);
          setAllDocuments(
            results.content.map((x) => {
              return {
                id: x.code,
                descriptionFr: x.name,
                code: x.code,
                category: x.category,
                selected: false
              };
            })
          );
        }
        catch {
          // TODO something
        }
      })();
    }
  }, [state.account, dispatch]);

  useEffect(() => {
    setIsDossierTypeCodeToIgnore(isSealedDossier(getValues("code")));
  }, [getValues])

  useEffect(() => {
    setFilteredDocuments(
      allDocuments?.filter(doc => 
        (!isDossierTypeCodeToIgnore && !isSealedDocument(doc.code)) || // Hide docs from other dossiers
        isDossierTypeCodeToIgnore // Keep them for specific dossiers
      )
    );
  }, [isDossierTypeCodeToIgnore, allDocuments])

  useEffect(() => {
    setSortedDocuments(
      filteredDocuments?.map(d => (
        {
          ...d,
          selected: documentsSelected?.includes(d.code)
        }
      )).sort((a, b) => (a.selected ? -1 : 1))
    );
  }, [documentsSelected, filteredDocuments]);

  const submitForm = (data) => {
    data = {
      ...data,
      docCode: documentsSelected,
      docToAdd: documentsSelected?.map(c => allDocuments.find(d => d.code === c)),
      active: getValues('active')
    };
    if (isEmpty(errors)) {
      setData(data);
      onContinue(data);
    }
  };

  const handleFinalizeSave = () => {
    handleSubmit(submitForm)();
  };

  return (
    <>
      {sortedDocuments ? (
        <DossierChoiceDocuments
          documents={sortedDocuments}
          selection={{
            items: documentsSelected,
            setItems: handleSelectionChange,
          }}
          isDossierTypeCodeToIgnore={isDossierTypeCodeToIgnore}
          context="dossier-model"
          readOnly={readOnly}
        />
      ) : (
        <>
          <EAIcon icon={"loop"} />
          <span style={{ fontWeight: "bold", textAlign: "center" }}>{i18next.t("loading")}</span>
        </>
      )}

      {/* --- Actions --- */}
      {/* Supprimer le modele */}
      <div className={classes.declarationControls}>
      {/* For now, we can't delete a model */}
{/*         {!isCreationMode &&
          <EAButton
            borderless={true}
            colorVariant="error"
            onClick={(e) => {
              e.preventDefault();
              onDelete([dossierModel?.id]);
            }}
            content={
              <div>
                <EAIcon
                  icon={"delete_red"}
                  className={classes.deleteModelImg}

                />
                {i18next.t("demandes.dossierModel.editDialog.deleteAction")}
              </div>
            }
            customStyle={{ fontSize: "14px", position: "absolute", bottom: "28px" }}
          />
        } */}

        {/* Annuler / Enregistrer / Activer */}
        <div className={classes.declarationControlsRight}>
          <EAButton
            onClick={(e) => {
              e.preventDefault();
              onCancel();
            }}
            content={i18next.t("cancel")}
            customStyle={{ width: "80px" }}
            colorVariant={"secondary"}
          />
          {!readOnly &&
            <EAButton
              onClick={(e) => {
                e.preventDefault();
                handleFinalizeSave();
              }}
              content={i18next.t("save")}
              colorVariant={"primaryLight"}
              customStyle={{ width: "117px" }}
            />
          }

          {!readOnly && !dossierModel?.active ? (
            <EAButton
              onClick={(e) => {
                e.preventDefault();
                setValue(`active`, true);
                handleFinalizeSave();
              }}
              content={i18next.t("activate")}
              customStyle={{ width: "117px" }}
            />
          ) : !readOnly && (
            <EAButton
              onClick={(e) => {
                e.preventDefault();
                setValue(`active`, false);
                handleFinalizeSave();
              }}
              disabled={isDossierTypeCodeToIgnore}
              content={i18next.t("deactivate")}
              colorVariant={"success"}
              customStyle={{ width: "117px" }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default DossierModelDialogDocStep;
